<app-loading *ngIf="contentReady"></app-loading>
<div class="invoice-container">
    <div class="invoice-header">
        <button onclick="window.print();" class="noPrint printbtn btn btn-primary">{{ 'Print' | translate }}</button>
        <img src="/assets/emploees.png" alt="Company Logo">
        <h1>{{name}}</h1>
        <p>{{ 'job title' | translate }}: {{job_title}}</p>
        <p>{{ 'salary' | translate }}: {{salary}}</p>
        <button class="btn btn-primary" (click)="paySalary()">
         {{ 'pay salary this month' | translate }}    {{currentMonth}}
        </button>
    </div>
    <div class="row">
        <div class="col-6">
            <label for="monthSelect">{{ 'Filter by Month' | translate }}:</label>
            <select id="monthSelect" [(ngModel)]="filteredMonth" (change)="filterByMonth()">
                <option *ngFor="let month of uniqueMonths" [value]="month">{{ month }}</option>
            </select>
        </div>
        <div class="col-6">
            <label for="dateSelect">{{ 'Filter by day' | translate }}:</label>
            <select id="dateSelect" [(ngModel)]="filteredDate" (change)="filterByDate()">
                <option *ngFor="let date of uniqueDates" [value]="date">
                    {{ date }}
                </option>
            </select>

        </div>
    </div>


    <div class="invoice-details row">
        <div class="col-sm-12 col-md-6">
        </div>
    </div>
    <button class="btn btn-primary" style="float: right;" (click)="addLoan()">
        {{ 'Add loan' | translate }}
    </button>
    <table class="invoice-table">
        <thead>
            <tr>
                <th>
                    {{ 'Loans' | translate }}


                </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let loan of loans">
                <td>{{ loan.amount }} - {{ loan.note }}</td>
            </tr>
        </tbody>
    </table>
    <button class="btn btn-primary" (click)="addBonuses()" style="float: right;">
        {{ 'Add Bonuse' | translate }}
    </button>
    <table class="invoice-table">
        <thead>
            <tr>
                <th> {{ 'Bonuses' | translate }}

                </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let bonuse of bonuses">
                <td style="color: green;">{{ bonuse.amount }} - {{ bonuse.note }}</td>
            </tr>
        </tbody>
    </table>
    <button class="btn btn-primary" (click)="addDeduction()" style="float: right;">
        {{ 'Add deduction' | translate }}
    </button>
    <table class="invoice-table">
        <thead>
            <tr>
                <th>{{ 'Deductions' | translate }}

                </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let deduction of deductions">
                <td style="color: red;">{{ deduction.amount }} - {{ deduction.note }}</td>
            </tr>
        </tbody>
    </table>
</div>

<div *ngIf="showFinPopUp" class="popup">

    <div class="maindev">
        <button (click)='close()' class="close btn btn-primary"> {{ "close" | translate }} </button>

        <img src="/assets/income.png">

        <div class="form d-flex flex-column flex-sm-row justify-content-center">
            <div class="form-group">
                <label class="label" for="quantity">{{ 'amount' | translate }} </label>
                <input class="input" type="text" id="not_payed" [(ngModel)]="amount"
                    placeholder="{{ 'amount' | translate }} " />
            </div>
            <div class="form-group">
                <label class="label" for="quantity">{{ 'note' | translate }}</label>
                <input class="input" type="text" id="payed" [(ngModel)]="note"
                    placeholder="{{ 'note' | translate }} " />
            </div>
        </div>
        <button (click)="onSubmit()" type="submit" class="submit-btn btn btn-primary">
            {{ "Submit" | translate }}
        </button>



    </div>
</div>